import Dropdown from './dropdown';
import { h } from './element';
import { baseFormats, baseSubFormulas} from '../core/format';
import { cssPrefix } from '../config';
import DropdownFormatSubItem from './dropdown_format_subitem';

export default class DropdownFormat extends Dropdown {
  constructor() {
    console.log("DropdownFormat constructor......");
    
    let nformats = baseFormats.slice(0);
    nformats.splice(2, 0, { key: 'divider' });
    nformats.splice(9, 0, { key: 'divider' });
    nformats = nformats.map((it) => {
      const item = h('div', `${cssPrefix}-item`);
      if (it.key === 'divider') {
        item.addClass('divider');
      } else {
        if (it.isSubItem) {
          item.child(it.title()).on('click', () => {
            this.setTitle(it.title());
            this.change(it);
          }).on('mouseenter', (evt) => {
            this.selectKey = it.key;
            this.dropdownFormatSubItem && this.dropdownFormatSubItem.show(it.key);
            let menuOffset = this.getMenuItemOffset(it.key);
            if (menuOffset) {
              this.dropdownFormatSubItem.setPosition(menuOffset.left+menuOffset.width, menuOffset.top);
            }
          }).on('mouseleave', (evt) => {
            this.selectKey = '';
            this.dropdownFormatSubItem && this.dropdownFormatSubItem.hide(it.key);
          });
          item.child(h('div', `${cssPrefix}-contextmenu-right-img-class`)).addClass(it.key);;
        } else {
          item.child(it.title())
          .on('click', () => {
            this.setTitle(it.title());
            this.change(it);
          }).addClass(it.key);;
          if (it.label) item.child(h('div', 'label').html(it.label));
        }
      }
      return item;
    });
    super('Normal', '220px', true, 'bottom-left', ...nformats);
    this.selectKey = '';
    this.dropdownFormatSubItem = new DropdownFormatSubItem(true);
    this.dropdownFormatSubItem.itemClick = (type) => {
      let selectFormat = baseSubFormulas.find(it=>it.type == type);
      console.log('type:', type);
      this.setTitle(selectFormat.title());
      this.change(selectFormat);
    };
    this.children(this.headerEl, this.contentEl,this.dropdownFormatSubItem.el);
  }

  setTitle(key) {
    for (let i = 0; i < baseFormats.length; i += 1) {
      if (baseFormats[i].key === key) {
        this.title.html(baseFormats[i].title());
      }
    }
    for (let i = 0; i < baseSubFormulas.length; i += 1) {
      if (baseSubFormulas[i].key === key) {
        this.title.html(baseSubFormulas[i].title());
      }
    }
    this.hide();
  }
}
